/* HI BAGS Smart Product Gallery — theme draft */
(() => {
 if (window.__hbSmartGallery) return;
 window.__hbSmartGallery = true;
 const find = el => el?.closest?.('media-gallery');
 const slides = gallery => [...(gallery.querySelector('[id^="GalleryViewer"] .product__media-list')?.children || [])].filter(el => el.matches('[data-media-id]'));
 const activeIndex = gallery => Math.max(0, slides(gallery).findIndex(el => el.classList.contains('is-active')));
 function move(gallery, dir) {
  const items=slides(gallery); if(items.length<2) return;
  const next=items[(activeIndex(gallery)+dir+items.length)%items.length];
  if(next && typeof gallery.setActiveMedia==='function') gallery.setActiveMedia(next.dataset.mediaId,false);
 }
 function decorate(gallery) {
  if(gallery.dataset.hbSmartReady) return;
  gallery.dataset.hbSmartReady='true';
  const viewer=gallery.querySelector('[id^="GalleryViewer"]');
  if(!viewer || slides(gallery).length<2) return;
  const nav=document.createElement('div');
  nav.className='hb-smart-controls';
  [[-1,'Previous image','‹'],[1,'Next image','›']].forEach(([dir,label,glyph])=>{
   const btn=document.createElement('button');btn.type='button';btn.className='hb-smart-nav '+(dir===-1?'hb-smart-prev':'hb-smart-next');
   btn.textContent=glyph;btn.setAttribute('aria-label',label);
   btn.addEventListener('click',e=>{e.preventDefault();e.stopPropagation();move(gallery,dir)});
   nav.appendChild(btn);
  });
  viewer.appendChild(nav);
 }
 function scan(){document.querySelectorAll('media-gallery').forEach(decorate)}
 if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',scan,{once:true}); else scan();
 document.addEventListener('shopify:section:load',scan);
 document.addEventListener('pointerover',e=>{
  if(e.pointerType && e.pointerType!=='mouse') return;
  const thumb=e.target.closest?.('[id^="GalleryThumbnails"] [data-target]');
  if(!thumb || thumb.contains(e.relatedTarget)) return;
  const gallery=find(thumb); if(!gallery || typeof gallery.setActiveMedia!=='function') return;
  const id=thumb.dataset.target; if(id && !gallery.querySelector('[data-media-id="'+id+'"].is-active')) gallery.setActiveMedia(id,false);
 });
 document.addEventListener('keydown',e=>{
  if(e.key!=='ArrowLeft' && e.key!=='ArrowRight') return;
  if(e.altKey||e.ctrlKey||e.metaKey||/^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement?.tagName||'')) return;
  const gallery=find(document.activeElement)||document.querySelector('media-gallery:hover');
  if(!gallery) return;
  e.preventDefault();move(gallery,e.key==='ArrowRight'?1:-1);
 });
})();